import { useEffect, useState } from 'react'
import {
  onChunkMissing,
  onUpdateAvailable,
  registerServiceWorker,
  applyUpdate as swApplyUpdate,
} from '@/lib/sw-registration'

export function useSwUpdate() {
  const [updateAvailable, setUpdateAvailable] = useState(false)

  useEffect(() => {
    onUpdateAvailable(() => setUpdateAvailable(true))
    onChunkMissing(() => setUpdateAvailable(true))
    registerServiceWorker()
  }, [])

  return {
    updateAvailable,
    applyUpdate: swApplyUpdate,
  }
}
